//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImagePicker from '@/components/innovation/ImagePicker.vue'
export default {
  components: { ImagePicker },
  data () {
    return {
      name: this.$route.query.name || '我的宫殿',
      templateId: this.$route.query.template_id || null,
      backgroundImage: '',
      submitting: false
    }
  },
  methods: {
    submit () {
      const name = (this.name || '').trim()
      if (!name) {
        this.$toast && this.$toast('请填写名称')
        return
      }
      this.submitting = true
      const body = {
        palace_name: name,
        theme_color: '#1E3A5F',
        background_image: this.backgroundImage || null
      }
      if (this.templateId) body.template_id = this.templateId
      this.$ajax.post(this.$api.mpPalaceCreate, body).then(res => {
        this.$toast && this.$toast('创建成功')
        this.$router.replace({ path: '/mpDetail_display', query: { id: res.id } })
      }).catch(e => {
        this.$toast && this.$toast(e.message || '创建失败')
      }).finally(() => { this.submitting = false })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/create.vue